
export const APPEND_TYPES = {
  ROUND_STOPPED: 'ROUND_STOPPED',
  ESCAPE: 'ESCAPE'
}

export const PAGINATION_LIMIT = 20

export const PER_PAGE_LIMIT = 7

export const DEFAULT_MY_BETS_LIMIT = 20

export const COIN_CURRENCY_ID = {
  GC: '1',
  SC: '2'
}

export const COIN_CURRENCY_CODES = {
  GC: 'GC',
  SC: 'SC'
}

export const DEFAULT_LIVE_STATS = { profit: 0, wins: 0, wagered: 0, losses: 0 }

export const DEFAULT_AUTO_BET_COUNT = 3
export const DEFAULT_AUTO_BET_MAX_COUNT = 50
